import { useMemo } from "react";
import { type SelectProps } from "antd";
import { formatSectionTwoSignerLabel } from "../../model/format-section-two-signer-label";
import "./party-suggestion.scss";
import { UserSelectOption, UserSelect } from "./index.ts";

// TODO : разобраться в типах
// перенести в project, или что-то ещё
interface UserSuggestionsProps extends SelectProps {
  onSignerSelect: (party: any) => void;
  users: Array<any>;
}

export function SignerSuggestions({
  onSignerSelect,
  users,
  ...rest
}: UserSuggestionsProps) {
  const onSelect = (value: string) => {
    const valueConverted = JSON.parse(value);
    const selected = users.find((el) => {
      const repIdMatch =
        el?.representativeId === valueConverted?.representativeId;

      const ccIdMatch =
        el?.constructionControlId === valueConverted?.constructionControlId ||
        el?.representativeId === valueConverted?.constructionControlId;

      return repIdMatch && ccIdMatch;
    });
    if (selected) {
      onSignerSelect(selected);
    }
  };

  const options = useMemo(
    () =>
      users.map((value) => {
        const inputLabel = formatSectionTwoSignerLabel(value);

        return {
          value: JSON.stringify({
            constructionControlId: value.representativeId,
            representativeId: value.representativeId,
          }),
          label: <UserSelectOption inputLabel={inputLabel} />,
          inputLabel,
          className: "party-suggestion",
        };
      }),
    [users],
  );

  return <UserSelect onSelect={onSelect} options={options} {...rest} />;
}
